import _ from 'underscore';

export default class OfferCutAnalysis {
  constructor($scope, $timeout, OfferService, ProductService, UserProductService) {
    $scope.quick_search = function() {
      window.filter_table('table#reels', $scope.query);
      window.filter_table('table#sheets', $scope.query);
    };


    $scope.combinations = [
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      },
      {
        value: 3,
        title: '3'
      },
    ];

    $scope.sort_by_options = [
      {
        value: 0,
        title: 'Combinations'
      },
      {
        value: 1,
        title: 'Sawed Paper Price'
      },
    ];

    $scope.value_sideruns_options = [
      {
        value: 0,
        title: 'Yes'
      },
      {
        value: 1,
        title: 'No'
      },
    ];

    $scope.create_offer = function() {
      $scope.checked_results = [];
      _.each($scope.results, function(item) {
        _.each(item.results, function(result) {
          if (result.checked == true) {
            $scope.checked_results.push(result);
          }
        });
      });
      OfferService.create_offer_from_cut_analysis($scope.checked_results, $scope.offer_id).then(function(data) {
        if (data.data.success) {
          window.open('/admin/marketplace/offers/edit_main_title/' + data.data.offer_id, '_blank').focus();
        }
      });
    };

    $scope.get_results = function() {
      $scope.items = [];
      $scope.loading = true;
      $scope.filter.widths = $scope.validate_specs($scope.filter.widths);
      OfferService.get_cut_pricing_results($scope.offer_stock_item_ids, $scope.filter).success(function(data) {
        console.log(data);
        $scope.results = data.results;
        $scope.results_string = JSON.stringify($scope.results);
        $scope.offer_stock_item = data.offer_stock_item;
        $scope.epaper_title = data.offer_stock_item_epaper_title;
        $scope.has_results = true;
        $scope.loading = false;
      });
    };

    $scope.load_specs = function() {
      if ($scope.product_group_ids){
        ProductService.get_product_group_specs($scope.product_group_ids, null).success(function(data) {
          $scope.filter.widths = data.specs;
          $scope.filter.widths = $scope.validate_specs($scope.filter.widths);
        });
      }
    };

    $scope.show_suggested = function(bool) {
      if (bool) {
        $scope.suggested_reels = [];
        $scope.loading_suggested_reels = true;
        ProductService.get_product_group_specs($scope.product_group_ids, null).success(function(data) {
          $scope.suggested_reels = data.specs;
          UserProductService.get_product_group_specs($scope.product_group_ids, true).success(function(data) {
            $scope.suggested_reels = _.union($scope.suggested_reels, data.specs);
            $scope.loading_suggested_reels = false;

            $scope.suggested_reels = $scope.validate_specs($scope.suggested_reels);
            $scope.showing_suggested = true;
            $scope.loading_suggested_reels = false;
          });
        });
      } else {
        $scope.showing_suggested = false;
      }
    };

    $scope.add_suggested = function() {
      var specs = null;
      specs = _.where($scope.suggested_reels, {
        checked: true
      });

      if (specs.length === 0) {
        alert('Please select at least one spec!');
      } else {
        _.each(specs, function(s) {
          var spec = {
            id: null,
            is_reels: true,
            spec_type: 1,
            is_accurate: true,
            value: s.value
          };
          $scope.filter.widths.push(spec);
        });
      }
      $scope.filter.widths = $scope.validate_specs($scope.filter.widths);
    };

    $scope.add_spec = function() {
      var spec = {
        id: null,
        is_reels: true,
        spec_type: 1,
        is_accurate: true,
        value: 0
      };
      $scope.filter.widths.push(spec);
    };

    $scope.validate_specs = function(specs) {
      var valid_specs = _.map(specs, function(o) {
        if (o.value != 0 && o.value <= _.max($scope.offer_stock_item_widths)) return o;
      });
      var validated_specs = [];
      validated_specs = _.without(valid_specs, undefined);
      validated_specs = _.uniq(validated_specs, 'value');

      validated_specs = _.sortBy(validated_specs, ['value']);

      return validated_specs;
    };

    $scope.export_xls = function() {
      OfferService.get_cut_analysis_xls($scope.offer_stock_item_ids, $scope.results).success(function(data) {
        console.log(data);
      });
    };

    $scope.get_filter = function() {
      return {
        widths: [],
        cuts: 0,
        combinations: 1,
        value_sideruns: 0,
        mode: 'cutting'
      };
    };

    $scope.reset_filter = function() {
      $scope.filter = $scope.get_filter();
    };

    $scope.get_analysis_url = function() {
      $scope.offer_stock_item_ids.push($scope.search_offer_stock_item_id);
      console.log($scope.offer_stock_item_ids);
      window.location.href = '/admin/marketplace/offers/edit_cut_pricing/' + $scope.offer_id + '?items=' + $scope.offer_stock_item_ids.join(',');
    };

    $scope.sort = function() {
      if ($scope.sort_by == 0){
        _.each($scope.results, function(item,i) {
          $scope.results[i].results = _.sortBy($scope.results[i].results, 'combination_count');
        });
      } else if ($scope.sort_by == 1) {
        _.each($scope.results, function(item,i) {
          $scope.results[i].results = _.sortBy($scope.results[i].results, 'price_sawed_paper');
        });
      }
    };

    $scope.init = function() {
      $scope._ = _;
      $scope.offer_id = window.offer_id;
      $scope.showing_suggested = false;
      $scope.product_group_ids = window.product_group_ids;
      $scope.offer_stock_item_ids = window.offer_stock_item_ids;
      $scope.offer_stock_item_widths = window.offer_stock_item_widths;
      $scope.filter = window.filter ? window.filter : $scope.get_filter();
      $scope.sort_by = 0;
      $scope.offer_stock_item_product_titles = window.offer_stock_item_product_titles;
      $scope.page_title = '';
      $scope.items_count = 0;
      _.each($scope.offer_stock_item_ids, function(id,i) {
        if (i > 0) {
          $scope.page_title = $scope.page_title + ', ';
        }
        $scope.page_title = $scope.page_title + $scope.offer_stock_item_product_titles[i] + '(' + id + ')';
        $scope.items_count++;
      });

    };

    $scope.init();
    //$scope.load_specs();
    $scope.loading = false;
  }
}

OfferCutAnalysis.$inject = ['$scope', '$timeout', 'OfferService', 'ProductService', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-cut-analysis.ctrl.js